export default __webpack_public_path__ + "static/media/trustero_ai_logo_black.b244c6e9.svg";